import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { TemplateSelectorConfiguration, TTag } from '@interfaces/nebula';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateListConfigurationResolverService implements Resolve<TemplateSelectorConfiguration> {
  private logger = inject(LoggerService);

  constructor() {
    this.logger.debug('Service started.');
  }

  resolve(route: ActivatedRouteSnapshot): Observable<TemplateSelectorConfiguration> {
    let category = route.paramMap.get('category');
    this.logger.debug('Service hat gekriegt: ' + category);
    let tags: TTag[];
    let title: string;

    if (category) {
      category = category.toLowerCase();
    }

    switch (category) {
      case 'submission':
        title = 'Vorgang erstellen';
        tags = [`app:document-type:${category}`];
        break;

      case 'agenda':
        title = 'Sitzungen planen';
        tags = [`app:document-type:${category}`];
        break;

      case 'project':
        title = 'Projekt erstellen';
        tags = [`app:document-type:${category}`];
        break;

      default:
        title = 'Bitte Dokumenttyp wählen';
        tags = [`app:document-type:${category}`];
        break;
    }
    return of({
      categories: tags,
      title: title
    });
  }
}
